module.exports = __webpack_public_path__ + "static/media/POTM_v1.2f8e2a54.jpg";